import React from "react";
import "./termspolicy.scss";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import { PublicService } from "../../services";
import { useQuery } from "@tanstack/react-query";
import { Helmet } from "react-helmet";

const Policy = () => {
  const { getPolicyApi } = PublicService();

  const privacy = useQuery({
    queryKey: ["privacy"],
    queryFn: () => getPolicyApi(),
  });

  return (
    <>
      <Helmet defer={false}>
        <title>Privacy Policy | Holypills Healthcare Platform</title>
        <meta
          name="description"
          content="Read the Holypills Privacy Policy to understand how we protect your data, ensure confidentiality, and safeguard your health information."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/policy" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Privacy Policy | Holypills Healthcare Platform"
        />
        <meta
          property="og:description"
          content="Read the Holypills Privacy Policy to understand how we protect your data, ensure confidentiality, and safeguard your health information."
        />

        <meta property="og:url" content="https://holypills.in/policy" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Privacy Policy | Holypills Healthcare Platform"
        />
        <meta
          name="twitter:description"
          content="Read the Holypills Privacy Policy to understand how we protect your data, ensure confidentiality, and safeguard your health information."
        />

        <meta name="twitter:url" content="https://holypills.in/policy"></meta>
      </Helmet>
      <Header />
      <div className="wrapper_terms_policy">
        <div className="container">
          <div className="custom_container">
            <div className="privacy_policy_title">
              <h1>Privacy Policy</h1>
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: privacy.data,
              }}
            ></p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Policy;
